import React from '../vendor/react';
import { createBrowserRouter, navigate } from '../vendor/react-router-dom';
import { AppLayout } from '../components/layout/AppLayout';
import { AdminGate, GuestGate, OnboardingGate, ProtectedGate } from '../components/auth/AuthGate';
import { FeatureGate, SubscriptionGate } from '../components/auth/SaasGate';
import { CatalogPage } from '../pages/CatalogPage';
import { DashboardPage } from '../pages/DashboardPage';
import { SettingsPage } from '../pages/SettingsPage';
import { ProductsPage } from '../pages/ProductsPage';
import { InventoryPage } from '../pages/InventoryPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { PosPage } from '../pages/PosPage';
import { ContextSelectorPage } from '../pages/ContextSelectorPage';
import { AccountPage } from '../pages/AccountPage';
import { CustomersPage } from '../pages/CustomersPage';
import { SuppliersPage } from '../pages/SuppliersPage';
import { PurchasesPage } from '../pages/PurchasesPage';
import { ExpensesPage } from '../pages/ExpensesPage';
import { OrdersPage } from '../pages/OrdersPage';
import { SpecialOrdersPage } from '../pages/SpecialOrdersPage';
import { SalesPage } from '../pages/SalesPage';
import { CashPage } from '../pages/CashPage';
import { TicketPage } from '../pages/TicketPage';
import { OnboardingPage } from '../pages/OnboardingPage';
import { LoginPage } from '../pages/auth/LoginPage';
import { RegisterPage } from '../pages/auth/RegisterPage';
import { RecoveryPage } from '../pages/auth/RecoveryPage';
import { ConfirmationPage } from '../pages/auth/ConfirmationPage';
import { MagicLinkPage } from '../pages/auth/MagicLinkPage';
import { ResetPasswordPage } from '../pages/auth/ResetPasswordPage';
import { AuthCallbackPage } from '../pages/auth/AuthCallbackPage';
import { ReportsPage } from '../pages/ReportsPage';
import { TransfersPage } from '../pages/TransfersPage';
import { MembershipsPage } from '../pages/MembershipsPage';
import { AuditPage } from '../pages/AuditPage';
import { NexoAiPage } from '../pages/NexoAiPage';
import { CollectionsPage } from '../pages/CollectionsPage';
import { ClosuresPage } from '../pages/ClosuresPage';
import { OfflineSyncPage } from '../pages/OfflineSyncPage';
import { PlanPage } from '../pages/PlanPage';
import { AdminLayout } from '../components/admin/AdminLayout';
import { AdminDashboardPage } from '../pages/admin/AdminDashboardPage';
import { AdminOrganizationsPage } from '../pages/admin/AdminOrganizationsPage';
import { AdminPlansPage } from '../pages/admin/AdminPlansPage';
import { AdminNoticesPage } from '../pages/admin/AdminNoticesPage';
import { AdminSupportPage } from '../pages/admin/AdminSupportPage';
import { CheckInPage } from '../pages/CheckInPage';
import { CheckInPublicPage } from '../pages/CheckInPublicPage';

export const router = createBrowserRouter([
  { path: '/', element: <DashboardRedirect /> },
  { path: '/ingresar', element: <GuestGate><LoginPage /></GuestGate> },
  { path: '/registro', element: <GuestGate><RegisterPage /></GuestGate> },
  { path: '/recuperar', element: <GuestGate><RecoveryPage /></GuestGate> },
  { path: '/restablecer', element: <GuestGate><ResetPasswordPage /></GuestGate> },
  { path: '/auth/confirmacion', element: <GuestGate><ConfirmationPage /></GuestGate> },
  { path: '/auth/magic', element: <GuestGate><MagicLinkPage /></GuestGate> },
  { path: '/auth/callback', element: <AuthCallbackPage /> },
  { path: '/onboarding', element: <OnboardingGate><OnboardingPage /></OnboardingGate> },
  {
    path: '/app',
    element: <ProtectedGate><SubscriptionGate><AppLayout /></SubscriptionGate></ProtectedGate>,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'pos', element: <PosPage /> },
      { path: 'seleccionar-contexto', element: <ContextSelectorPage /> },
      { path: 'cuenta', element: <AccountPage /> },
      { path: 'productos', element: <ProductsPage /> },
      { path: 'pedidos', element: <FeatureGate feature="catalogOrders"><OrdersPage /></FeatureGate> },
      { path: 'pedidos-especiales', element: <FeatureGate feature="specialOrders"><SpecialOrdersPage /></FeatureGate> },
      { path: 'ventas', element: <SalesPage /> },
      { path: 'ventas/:saleId', element: <TicketPage /> },
      { path: 'inventario', element: <InventoryPage /> },
      { path: 'clientes', element: <CustomersPage /> },
      { path: 'clientes-en-tienda', element: <FeatureGate feature="customerCheckIn"><CheckInPage /></FeatureGate> },
      { path: 'proveedores', element: <SuppliersPage /> },
      { path: 'compras', element: <PurchasesPage /> },
      { path: 'gastos', element: <ExpensesPage /> },
      { path: 'caja', element: <CashPage /> },
      { path: 'reportes', element: <ReportsPage /> },
      { path: 'transferencias', element: <FeatureGate feature="transfers"><TransfersPage /></FeatureGate> },
      { path: 'membresias', element: <FeatureGate feature="memberships"><MembershipsPage /></FeatureGate> },
      { path: 'cobranza', element: <CollectionsPage /> },
      { path: 'cierres', element: <ClosuresPage /> },
      { path: 'auditoria', element: <AuditPage /> },
      { path: 'nexo-ia', element: <NexoAiPage /> },
      { path: 'sincronizacion', element: <OfflineSyncPage /> },
      { path: 'plan', element: <PlanPage /> },
      { path: 'configuracion', element: <SettingsPage /> },
    ],
  },
  {
    path: '/admin',
    element: <AdminGate><AdminLayout /></AdminGate>,
    children: [
      { index: true, element: <AdminDashboardPage /> },
      { path: 'organizaciones', element: <AdminOrganizationsPage /> },
      { path: 'planes', element: <AdminPlansPage /> },
      { path: 'avisos', element: <AdminNoticesPage /> },
      { path: 'soporte', element: <AdminSupportPage /> },
    ],
  },
  { path: '/catalogo/:slug', element: <CatalogPage /> },
  { path: '/check-in/:token', element: <CheckInPublicPage /> },
  { path: '*', element: <NotFoundPage /> },
]);

function DashboardRedirect() {
  navigate('/app', { replace: true });
  return null;
}
